import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './HamburgerMenu.css';

function HamburgerMenu({ onClose }) {
  const { user, isAnnotator, signIn, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Close on Escape key
  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose]);

  const go = (path) => {
    navigate(path);
    onClose();
  };

  const handleSignOut = async () => {
    await signOut();
    onClose();
  };

  const handleSignIn = () => {
    onClose();
    signIn();
  };

  const item = (path, label) => (
    <li>
      <button
        className={`menu-item ${location.pathname === path ? 'menu-item--active' : ''}`}
        onClick={() => go(path)}
      >
        {label}
      </button>
    </li>
  );

  return (
    <>
      {/* Backdrop */}
      <div className="menu-backdrop" onClick={onClose} aria-hidden="true" />

      {/* Drawer */}
      <nav className="menu-drawer" aria-label="Main menu">
        <button className="menu-close-btn" onClick={onClose} aria-label="Close menu">✕</button>

        <ul className="menu-list">
          {item('/about', 'About')}
          {item('/', 'Hoja')}
          {item('/dictionary', 'Dictionary')}
          {isAnnotator && item('/annotate', 'Annotate')}
          {item('/settings', 'Settings')}
          <li className="menu-divider" />
          {user ? (
            <li>
              <button className="menu-item menu-item--logout" onClick={handleSignOut}>
                Sign out
              </button>
            </li>
          ) : (
            <li>
              <button className="menu-item" onClick={handleSignIn}>Annotator sign in</button>
            </li>
          )}
        </ul>
      </nav>
    </>
  );
}

export default HamburgerMenu;
